<template>
  <Modal title="Crear Libreria" @close="emitClose">
    <form @submit.prevent="createLibrary">
      <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
        <div class="col-span-6 sm:col-span-6">
          <label>Nombre:</label>
          <input type="text" class="input w-full border mt-2 flex-1" v-model="library.name" required>
        </div>
        <div class="col-span-6 sm:col-span-6">
          <label>Estado:</label>
          <select class="input w-full border mt-2 flex-1" v-model="library.active" required>
            <option :value="1">Activo</option>
            <option :value="0">Inactivo</option>
          </select>
        </div>
        <div class="col-span-12 sm:col-span-12">
          <label>Descripción:</label>
          <textarea class="input w-full border mt-2 flex-1" v-model="library.description" required></textarea>
        </div>
        <div class="col-span-6 sm:col-span-6">
          <label>Categoria</label>
          <select class="input w-full border mt-2 flex-1" v-model="library.category" required>
            <option :value="null" disabled>Seleccionar...</option>
            <option v-for="category in categories" :value="category.name" :key="`category-${category.name}`">
              {{category.name}}
            </option>
          </select>
        </div>
        <div class="col-span-6 sm:col-span-6">
          <label>Visualización</label>
          <select class="input w-full border mt-2 flex-1" v-model="library.team_id">
            <option :value="null">TODOS</option>
            <template v-for="team in teams">
              <option :value="team.id" :key="`team-${team.id}`">
              {{team.name}}
              </option>
            </template>
          </select>
        </div>
        <div class="col-span-6 sm:col-span-6">
            <label>Creado Por</label>
            <select class="input w-full border mt-2 flex-1" v-model="library.team_createdby_id">
              <option :value="null">TODOS</option>
              <template v-for="team in teams">
                <option :value="team.id" :key="`team-${team.id}`">
                {{ team.name }}
                </option>
              </template>
            </select>
          </div>
        <div class="col-span-12 sm:col-span-12">
          <label>Url:</label>
          <input type="text" class="input w-full border mt-2 flex-1" v-model="library.url"
            placeholder="No es necesaria para Tips o Anuncios">
        </div>
      </div>
      <div class="px-5 py-3 text-right border-t border-gray-200">
        <button type="button" class="button w-20 border text-gray-700 mr-1" @click="emitClose">
          Cancelar
        </button>
        <button type="submit" class="button w-20 bg-theme-1 text-white" id="create">
          Crear
        </button>
      </div>
    </form>
  </Modal>
</template>

<script>
  import { mapActions } from 'vuex'
  import Modal from '@/components/assets/Modal/Modal'

  export default {
    props: [
      'categories',
      'teams'
    ],
    data() {
      return {
        library: this.defineLibrary(),
      }
    },
    methods: {
      defineLibrary() {
        return {
          name: '',
          description: '',
          active: 1,
          url: '',
          category: null,
          team_id: null,
          team_createdby_id: null,
          entity: 'library',
        }
      },
      createLibrary() {
        var vm = this
        window.$('#create').button('loading')
        vm.store(vm.library).then(item => {
          this.$emit('created')
        }).finally(() => {
          window.$('#create').button('reset')
          this.library = this.defineLibrary()
        });
      },
      emitClose() {
        this.$emit('close')
      },
      ...mapActions([
        'store'
      ])
    },
    components: {
      Modal
    }
  }
</script>



// WEBPACK FOOTER //
// ModalCreateLibrary.vue?40a1800a